export default "__VITE_ASSET__a2fa04b1__"